import { render, staticRenderFns } from "./postBDZ.vue?vue&type=template&id=4459c3c4&scoped=true"
import script from "./postBDZ.vue?vue&type=script&lang=js"
export * from "./postBDZ.vue?vue&type=script&lang=js"
import style0 from "./postBDZ.vue?vue&type=style&index=0&id=4459c3c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4459c3c4",
  null
  
)

export default component.exports